import endOfDay from "date-fns/endOfDay";
import endOfMonth from "date-fns/endOfMonth";
import startOfMonth from "date-fns/startOfMonth";
import subDays from "date-fns/subDays";
import subMonths from "date-fns/subMonths";
import subYears from "date-fns/subYears";

export const DEFAULT_DATE_RANGES = {
  currentWholeMonth: {
    from: startOfMonth(new Date()),
    to: endOfMonth(new Date()),
  },
  lastWholeMonth: {
    from: startOfMonth(subMonths(new Date(), 1)),
    to: endOfMonth(subMonths(new Date(), 1)),
  },
  lastThreeMonths: {
    from: startOfMonth(subMonths(new Date(), 3)),
    to: endOfMonth(new Date()),
  },
  currentWholeYear: {
    from: startOfMonth(subMonths(new Date(), 11)),
    to: endOfMonth(new Date()),
  },
  lastTwelveMonths: {
    from: startOfMonth(subYears(new Date(), 1)),
    to: endOfMonth(new Date()),
  },
  last30Days: {
    from: subDays(new Date(), 30),
    to: endOfDay(new Date()),
  },
} as const;

export const convertDateRangeToISO = (
  dateRange: (typeof DEFAULT_DATE_RANGES)[keyof typeof DEFAULT_DATE_RANGES]
) => ({
  from: dateRange.from.toISOString(),
  to: dateRange.to.toISOString(),
});
